module.exports = __webpack_public_path__ + "img/Moyses_Icon.ae003e62.png";